// extracted by mini-css-extract-plugin
module.exports = {"container":"Preferred_container__1NSh6"};